import { FC, useState } from "react";
import Breadcrumbs from "@/components/entities/breadcrumbs";
import HeaderBackground from "@/components/ui/header-background";
import { useTranslations } from "next-intl";
import { Button } from "@/components/ui/button";
import SupportModal from "@/components/entities/support-block/support-modal";
import QuestionModal from "../favorites-question-modal";
import { useStrictLocale } from "@/hooks/locale/useStrictLocale/useStrictLocale";
import { Locales } from "@/hooks/locale/useChangeLocale/types";
import { Container } from "@/components/ui/container";
import S from "./index.module.scss";
import clsx from "clsx";
import { FeedbackResourceFormEnum } from "@/api/generated-api";

interface IFavoritesHeader {
  count: number;
}

export const FavoritesHeader: FC<IFavoritesHeader> = ({ count }) => {
  const t = useTranslations();
  const locale = useStrictLocale();
  const [openQuestion, setOpenQuestion] = useState(false);
  const [openForm, setOpenForm] = useState(false);

  const counter = count === 0 ? t("noItems") : t("productsCount", { count });

  const breadcrumbs = [{ title: t("home"), url: "/" }];

  return (
    <>
      <HeaderBackground type="black" />
      <Container>
        <div className={clsx(S.headerWrapper, { [S["headerWrapper--empty"]]: !count })}>
          <Breadcrumbs breadcrumbs={breadcrumbs} />
          <div className={S.headerInfo}>
            <h1 className={S.title}>{t(count !== 0 ? "favoritesList" : "myFavorites")}</h1>
            <p className={S.counter}>{counter}</p>
          </div>
          {locale === Locales.UK && (
            <div className={S.buttonWrapper}>
              <Button onClick={() => setOpenQuestion(true)}>Поставити питання</Button>
              <Button onClick={() => setOpenForm(true)}>Запросити комерційну пропозицію</Button>
            </div>
          )}
        </div>
        {openForm && (
          <SupportModal
            form={FeedbackResourceFormEnum.Favorites}
            onClose={() => setOpenForm(false)}
            title="Запросити комерційну пропозицію"
          />
        )}
        {openQuestion && <QuestionModal onClose={() => setOpenQuestion(false)} />}
      </Container>
    </>
  );
};

export default FavoritesHeader;
